import { DtacBase } from './dtac-base';
import { Value, VALUE_TEMPLATE } from './value';

export interface Dimensions extends DtacBase {
  width: Value;
  length: Value;
  height: Value;
  volume: Value;
};

export const DIMENSION_TEMPLATE: Dimensions = {
  '@id': '',
  '@type': '',
  width: VALUE_TEMPLATE,
  length: VALUE_TEMPLATE,
  height: VALUE_TEMPLATE,
  volume: VALUE_TEMPLATE
};
